import React, { useState, useMemo } from 'react';

import { FORMS } from '../../schemas/stepMap';
import { projectionCalculator } from '../SummaryPage/Comparison/projectionCalculator';
import graphDataFormatter from '../SummaryPage/Comparison/graphDataFormatter';
import SummaryProjection from '../SummaryPage/SummaryProjection';

const graphSelectOptions = [
  {
    name: 'monthlyNOI',
    description: 'Monthly Income After Operating Expenses',
    label: 'Net Income',
  },
  {
    name: 'totalEquity',
    description:
      'Total Equity Based on the Estimated Market Value of the Property on Purchase',
    label: 'Total Equity',
  },
  {
    name: 'annualPreTaxCashFlow',
    description: 'Annual Pre-Tax Cash Flow',
    label: 'Cash Flow',
  },
  {
    name: 'totalRoiYear1Amount',
    description: 'Return On Investment',
    label: 'ROI',
  },
  {
    name: 'marketPurchasePrice',
    description:
      'Property Value Based on the estimated property value on purchase (not purchase price)',
    label: 'Property Value',
  },
  {
    type: 'stack',
    stackIncludes: [
      { name: 'yearOnePrincipalReduction', label: 'Principal' },
      {
        name: 'interest',
        label: 'Interest',
        derivedFrom: [
          'monthlyDebtService',
          'balloonPayment',
          'yearOnePrincipalReduction',
        ],
        calcFunction: (
          monthlyDebtService,
          balloonPayment,
          yearOnePrincipalReduction
        ) =>
          monthlyDebtService +
          (balloonPayment || 0) -
          yearOnePrincipalReduction,
      },
    ],
    description: 'Mortgage Payments over the years',
    label: 'Amortization',
  },
];

export default function ProjectionsSummary({ propertyData }) {
  const [graph, setGraph] = useState(0);
  const [years, setYears] = useState(30);

  const projectionForm = FORMS.projection;

  const purchaseSchema = projectionForm.schema.calculations.schema[0];
  const purchaseFields = purchaseSchema.schema;

  const projectionData = useMemo(
    () => projectionCalculator(years, purchaseFields, propertyData),
    [years, propertyData]
  );

  const graphData = graphDataFormatter(
    years,
    projectionData,
    {},
    {},
    graphSelectOptions[graph]?.name,
    null,
    null,
    'single',
    graphSelectOptions[graph]
  );
  return (
    <div>
      <SummaryProjection
        options={graphSelectOptions}
        currOption={graph}
        setOption={setGraph}
        years={years}
        setYears={setYears}
        graphData={graphData}
        tableData={projectionData}
        schema={purchaseSchema}
        propertyData={propertyData}
      />
    </div>
  );
}
